<template>
  <dialChangeStatus
    :orderId="orderId"
    ref="dialChangeStatus"
  ></dialChangeStatus>
</template>
<script>
import { mapGetters } from 'vuex'
import dialChangeStatus from '../email/changeStatus.vue'
export default {
  components: {
    dialChangeStatus
  },
  props: {
    app_label: {
      type: [String]
    },
    model: {
      type: [String]
    },
    condition: {
      type: [Boolean]
    },
    customerNotification: {
      type: [Boolean]
    },
    stateMain: {
      type: [String]
    },
    stateID: {
      type: [Number],
      default: null
    },
    template: {
      type: [Number],
      default: null
    },
    subject: {
      type: [String]
    },
    recipient_list: {
      type: [String]
    },
    orderId: {
      type: Number
    }
  },
  data() {
    return {
      email: {
        id: '',
        user: '',
        company_id: '',
        subject: '',
        body: '',
        recipient_list: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      me: 'session/me',
      company: 'company/getCompanyData'
    }),
    /**
     * send_email
     * Computado para validar el envío de correo
     * El correo no se envía los siguientes casos:
     * - Si el cliente no tiene activo recibir notificaciones
     * - Si el subEstado de subOrden no tiene activa la notificación de correo
     * - Si la orden está en proceso y root es nulo
     * - Si 'condition' es falso
     *
     * Rosana Mendez <rosanamendez5 at gmail.com>
     */
    send_email: function () {
      if (!this.customerNotification) return false
      if (!this.condition) return false
      if (this.stateMain === 'in_process' && this.stateID === null) return false
      return true
    }
  }
}
</script>
